<template>
  <v-container>
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
      <v-spacer/>
        <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
          <indicacao-organizacao-lista-indicados />
    </v-card>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import IndicacaoOrganizacaoListaIndicados from '@/modules/organizacao/views/IndicacaoOrganizacaoListaIndicados';

export default {
  name: 'ListaInscritos',
  components: {
    IndicacaoOrganizacaoListaIndicados,
  },
  data: () => ({
    loading: false,
    pesquisar: '',
    tabs: 'conselho',
  }),
  computed: {
    ...mapGetters({
    }),
  },
  methods: {
    ...mapActions({
    }),
  },
};
</script>
